import React from 'react';
import cn from 'classnames';
import { TextDesktop as Text } from '@alfa-bank/site-text-v2/desktop';
import { IconGeo } from '@alfa-bank/site-icon/geo';

import type { ICityTag } from './models';
import styles from './styles.css';

export const CityTag = ({ cityName, onClick, showGeoIcon }: ICityTag) => (
    <li className={styles.cityTag}>
        <button className={styles.button} onClick={onClick} tabIndex={0}>
            {showGeoIcon && (
                <IconGeo className={cn(styles.external, styles.icon)} height={12} width={12} />
            )}
            <Text tag="span" view="component-secondary">
                {cityName}
            </Text>
        </button>
    </li>
);
